import { SENSOR_SIGNAL_TYPE, STATUS, TIME_LINE_CHUNKS } from "@shared/constants";
import { SensorDataScale } from "@shared/models";

import { Option, OptionWithData } from "./Option.interface";

export enum ORDER_TYPE {
  ASC = "ASC",
  DESC = "DESC",
  NONE = "",
}

export enum DATE_FORMAT_TYPE {
  SHORT = "SHORT",
  SHORT_WITHOUT_TIME = "SHORT_WITHOUT_TIME",
}

export enum USAGE_STATUS {
  ALL = "",
  TAKEN = "Taken",
  AVAILABLE = "Available",
}

export enum PATIENT_TYPE {
  ALL = "",
  NEW = "New",
}

export enum FORM_OWNER_TYPE {
  PATIENT = "patient",
  STAFF = "staff",
}

export interface Filter {
  page: number;
  limit: number;
  search?: string;
  sort_by?: string[];
  sort_order?: ORDER_TYPE;
}

export interface PatientFormFilter extends Filter {
  owner_type: FORM_OWNER_TYPE;
}

export interface SensorDataFileFilter extends Filter {
  is_original?: boolean;
}

export interface SensorDataSessionMarkerFilter {
  session_id: number;
}

export interface SensorDataFileValueFilter {
  start?: string;
  end?: string;
  interval?: Option<number>;
  dots?: string;
}

export interface SensorDataSessionValuesFilter {
  start?: string;
  end?: string;
  interval?: Option<number>;
  dots?: string;
  files?: number[];
  station?: string;
}

export interface StationViewRawDataFilter {
  interval: Option<number>;
  start: string;
  end: string;
}

export interface SensorDataSessionProcessedValuesFilter {
  id: number;
  time: string;
  station_code: string;
}

export interface UserFilter extends Filter {
  status?: STATUS;
  hospital?: Option | null;
}

export interface SensorDataRestoringRequestFilter extends Filter {
  hospital_id: number | null;
}

export interface UserFilterFormatted extends Filter {
  status?: STATUS;
  hospital_id?: number;
}

export interface SensorFilter extends Filter {
  usage_status: USAGE_STATUS;
  status?: STATUS;
  hospital?: Option | null;
}

export interface StationIssueFilter extends Filter {
  hospital_id?: number;
}

export interface GetStationsConnectionsFilter {
  stations_codes: string[];
}

export interface StationFilter extends Filter {
  usage_status: USAGE_STATUS;
  hospital?: Option | null;
  status?: STATUS;
}

export interface StationFilterFormatted extends Filter {
  usage_status: USAGE_STATUS;
  hospital_id?: number;
}
export interface AlertFilter {
  user_id?: number;
  hospital_id: number;
}
export interface PatientFilter extends Filter {
  type?: PATIENT_TYPE;
  assigned_user?: Option | null;
  status?: STATUS;
  hospital?: Option | null;
}
export interface PatientFilterFormatted extends Filter {
  assigned_user_id?: number;
  hospital_id?: number;
}

export interface DashboardStationStateChartFilter {
  sensors: number[];
  from: Date | null;
  to: Date | null;
  page: number;
  scale: SensorDataScale;
  limit: number;
}

export interface GetPatientDetailedSensorsDataFilter {
  date_from: Date;
  date_to: Date;
}

export interface GetPatientSensorsAverageDataFilter extends Filter {
  from: Date;
  to: Date;
}

export interface PatientDetailedChartFilter {
  from: Date | string | null;
  to: Date | string | null;
  patient_id: number | null;
  scale: OptionWithData<number, TIME_LINE_CHUNKS>;
  page: number;
  limit: number;
}

export interface PatientDailyChartFilter {
  from: Date | string | null;
  to: Date | string | null;
  patient_id: number | null;
  page: number;
  limit: number;
}

export interface AlertNotificationFilter extends Filter {
  patient_id?: number;
  hospital_id?: number;
  signal_type?: SENSOR_SIGNAL_TYPE;
  selector_type?: SENSOR_SIGNAL_TYPE;
  unread?: boolean;

  start_date?: Date | string | null;
  end_date?: Date | string | null;
}

export interface SensorDataSessionFilter extends Filter {
  hospital?: Option | null;
}

export interface SensorDataSessionFilterFormatted extends Filter {
  hospital_id?: number;
}

export interface RoleFilter {
  hospital_id: number;
}
